'use client'
// @ts-ignore
import { useFormStatus } from 'react-dom'

export function SubmitButton({
  label,
  loadingLabel
}: {
  label: string
  loadingLabel: string
}) {
  const data = useFormStatus()

  return (
    <button
      className="disabled::pointer-events-none rounded-full bg-brand-blue px-6 py-2.5 text-sm font-normal text-white shadow-sm transition-colors duration-200 hover:bg-blue-950 hover:text-brand-pink focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-indigo-600 disabled:opacity-30 hover:disabled:text-white group-invalid:pointer-events-none group-invalid:opacity-30"
      type="submit"
      aria-disabled={data.pending}
      disabled={data.pending}
    >
      {data.pending && (
        <svg
          xmlns="http://www.w3.org/2000/svg"
          fill="none"
          aria-hidden="true"
          className="mr-3 inline h-4 w-4 animate-spin text-gray-200 dark:text-gray-600"
          viewBox="0 0 100 101"
        >
          <path
            fill="currentColor"
            d="M100 50.59c0 27.615-22.386 50.001-50 50.001s-50-22.386-50-50 22.386-50 50-50 50 22.386 50 50Zm-90.919 0c0 22.6 18.32 40.92 40.919 40.92 22.599 0 40.919-18.32 40.919-40.92 0-22.598-18.32-40.918-40.919-40.918-22.599 0-40.919 18.32-40.919 40.919Z"
          />
          <path
            fill="#FFFFFF"
            d="M93.968 39.04c2.425-.636 3.894-3.128 3.04-5.486A50 50 0 0 0 41.735 1.279c-2.474.414-3.922 2.919-3.285 5.344.637 2.426 3.12 3.849 5.6 3.484a40.916 40.916 0 0 1 44.131 25.769c.902 2.34 3.361 3.802 5.787 3.165Z"
          />
        </svg>
      )}
      {data.pending ? loadingLabel : label}
    </button>
  )
}
